/** Необязательные наблюдатели не могут сорвать запрос CRM или изменить его результат. */
type Completion = (response: unknown) => void;
type Observer = (path: string, init: RequestInit) => Completion | undefined;
const observers = new Set<Observer>();
export function observeApiActivity(observer: Observer): () => void {
  observers.add(observer);
  return () => { observers.delete(observer); };
}
export function beginApiActivity(path: string, init: RequestInit): Completion {
  const completions: Completion[] = [];
  for (const observer of observers) {
    try { const complete = observer(path, init); if (complete) completions.push(complete); } catch { /* Дополнение не влияет на CRM. */ }
  }
  return response => { for (const complete of completions) { try { complete(response); } catch { /* Дополнение не влияет на CRM. */ } } };
}
